module.exports = __webpack_public_path__ + "img/Dantam Bridal 15b.1fa4de1f.jpg";